<rt-locations-section
  [locationsControl]="locationsControl"
  [readOnly]="!isFormEditable"
  [singleLocationMode]="false"
  [viewContext]="LocationsSectionViewContext.Requisition"
></rt-locations-section>
